(function () {
  var STARTING_POINTS = 480;
  var STEP = 100;
  var STORAGE_KEY = "sm-rewards-preview";

  function boot() {
    var root = document.querySelector("[data-rewards-preview]");
    if (!root || root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    var state = load();
    var selected = STEP;
    var view = "member";

    var pointsEl = root.querySelector("[data-points]");
    var pointsLabel = root.querySelector("[data-points-label]");
    var worthEl = root.querySelector("[data-worth]");
    var offerEl = root.querySelector("[data-offer]");
    var redeemBtn = root.querySelector("[data-redeem]");
    var minusBtn = root.querySelector("[data-minus]");
    var plusBtn = root.querySelector("[data-plus]");
    var hintEl = root.querySelector("[data-hint]");
    var codeBox = root.querySelector("[data-code]");
    var codeValue = root.querySelector("[data-code-value]");
    var activityEl = root.querySelector("[data-activity]");

    function load() {
      try {
        var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "");
        if (saved && typeof saved.points === "number" && Array.isArray(saved.activity)) return saved;
      } catch (error) {}
      return fresh();
    }

    function fresh() {
      return {
        points: STARTING_POINTS,
        activity: [
          { title: "Sample order, $36.00", detail: "2 points per $1 · +72 points" }
        ]
      };
    }

    function save() {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    }

    function dollars(points) {
      return Math.floor(points / STEP);
    }

    function render() {
      var member = view === "member";
      root.querySelectorAll("[data-member]").forEach(function (el) {
        el.hidden = !member;
      });
      root.querySelectorAll("[data-guest]").forEach(function (el) {
        el.hidden = member;
      });
      root.querySelectorAll("[data-view]").forEach(function (button) {
        button.setAttribute("aria-pressed", button.dataset.view === view ? "true" : "false");
      });

      var maxRedeem = dollars(state.points) * STEP;
      if (selected > maxRedeem) selected = maxRedeem;
      if (selected < STEP && maxRedeem >= STEP) selected = STEP;

      pointsEl.textContent = String(state.points);
      pointsLabel.textContent = state.points === 1 ? "point" : "points";
      var available = dollars(state.points);
      worthEl.textContent = available === 0 ? "100 points needed to redeem $1" : "$" + available + " off available";

      if (maxRedeem < STEP) {
        offerEl.textContent = "Not enough points yet";
        redeemBtn.disabled = true;
        redeemBtn.textContent = "Get discount code";
        minusBtn.disabled = true;
        plusBtn.disabled = true;
      } else {
        offerEl.textContent = selected + " points for $" + (selected / STEP) + " off";
        redeemBtn.disabled = false;
        redeemBtn.textContent = "Get $" + (selected / STEP) + " off code";
        minusBtn.disabled = selected <= STEP;
        plusBtn.disabled = selected >= maxRedeem;
      }

      activityEl.replaceChildren();
      state.activity.forEach(function (item) {
        var li = document.createElement("li");
        var title = document.createElement("span");
        title.textContent = item.title;
        var detail = document.createElement("small");
        detail.textContent = item.detail;
        li.appendChild(title);
        li.appendChild(detail);
        activityEl.appendChild(li);
      });
    }

    root.querySelector("[data-minus]").addEventListener("click", function () {
      selected = Math.max(STEP, selected - STEP);
      codeBox.hidden = true;
      render();
    });

    root.querySelector("[data-plus]").addEventListener("click", function () {
      var maxRedeem = dollars(state.points) * STEP;
      selected = Math.min(maxRedeem, selected + STEP);
      codeBox.hidden = true;
      render();
    });

    redeemBtn.addEventListener("click", function () {
      var maxRedeem = dollars(state.points) * STEP;
      if (selected < STEP || selected > maxRedeem) return;
      var amount = selected / STEP;
      state.points -= selected;
      var code = "PREVIEW-" + amount + "OFF";
      state.activity.unshift({
        title: "Redeemed $" + amount + " off",
        detail: "Sample code " + code + " · -" + selected + " points"
      });
      save();
      codeValue.textContent = code;
      codeBox.hidden = false;
      hintEl.hidden = true;
      selected = STEP;
      render();
    });

    root.querySelector("[data-reset]").addEventListener("click", function () {
      state = fresh();
      selected = STEP;
      codeBox.hidden = true;
      save();
      render();
    });

    root.querySelectorAll("[data-view]").forEach(function (button) {
      button.addEventListener("click", function () {
        view = button.dataset.view;
        codeBox.hidden = true;
        render();
      });
    });

    save();
    render();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
